__turbopack_context__.v({
  "article": "_2-DL2q_article",
  "authorBack": "_2-DL2q_authorBack",
  "embedLink": "_2-DL2q_embedLink",
  "embedWrapper": "_2-DL2q_embedWrapper",
  "heroImage": "_2-DL2q_heroImage",
  "metaLeft": "_2-DL2q_metaLeft",
  "metaRow": "_2-DL2q_metaRow",
  "readTime": "_2-DL2q_readTime",
  "releaseDate": "_2-DL2q_releaseDate",
  "similar": "_2-DL2q_similar",
  "similarCard": "_2-DL2q_similarCard",
  "similarList": "_2-DL2q_similarList",
});
